<template>
  <b-card no-body class="mb-2">
    <b-card-header
      header-tag="header"
      class="p-1"
      role="tab">
      <div
        class="p-2 accordion-target"
        v-b-toggle="accordionId">
        <strong>
          {{title}}
        </strong>
      </div>
    </b-card-header>
    <b-collapse
      :id="accordionId"
      accordion="my-accordion"
      role="tabpanel">
      <b-card-body>
        <b-card-text>
          <slot/>
        </b-card-text>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: 'CollapseListItem',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    accordionId() {
      return this.title
        .toLowerCase()
        .split(' ')
        .join('-')
    },
  },
}
</script>

<style lang="scss" scoped>
.accordion-target {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
